(() => {
/**
 * @file
 * Karhu Helsinki theme javascripts
 */ (function($, Drupal1, drupalSettings1) {
    "use strict";
    // Configuration of the observer:
    const observerConf = {
        attributes: true,
        childList: true,
        characterData: true
    };
    const linkSelector = ".sf-accordion li.sf-depth-1";
    Drupal1.behaviors.trestonMenu = {
        additionalLinks: [],
        observer: new MutationObserver(function(mutations) {
            mutations.forEach(Drupal1.behaviors.trestonMenu.mutationCallback);
        }),
        mutationCallback: (mutation)=>{
            const { addedNodes: addedNodes } = mutation;
            if (addedNodes !== null) addedNodes.forEach((node)=>{
                const menuItems = node.querySelectorAll(linkSelector);
                if (menuItems.length) {
                    Drupal1.behaviors.trestonMenu.addAdditionalLinksToMobileMenu(menuItems);
                    // We dont need observer anymore
                    Drupal1.behaviors.trestonMenu.observer.disconnect();
                }
            });
        },
        addAdditionalLinksToMobileMenu: (items)=>{
            var lastItem = items[0];
            for(var i = 0; i < items.length; i++){
                if (items[i].classList.contains("secondary-menu-item")) break;
            }
            i -= 1;
            Drupal1.behaviors.trestonMenu.additionalLinks.forEach((additionalNode)=>{
                var childGuest = document.createElement("li");
                childGuest.classList = additionalNode.classList;
                childGuest.innerHTML = additionalNode.querySelector("a").parentNode.innerHTML;
                items[i].parentNode.insertBefore(childGuest, items[i].nextSibling);
            });
        },
        attach: (context, settings)=>{
            var dLink = context.querySelector("#block-3dlink");
            var reqOffer = context.querySelector("#block-requestanofferlink");
            var menu = context.querySelector("#block-mainnavigationenglish");
            if (!menu) return;
            if ($("#block-mainnavigationenglish .block-_d-header").length < 1) Drupal1.behaviors.trestonMenu.additionalLinks.push(reqOffer);
            if ($("#block-mainnavigationenglish .block-request-offer-link").length < 1) Drupal1.behaviors.trestonMenu.additionalLinks.push(dLink);
            var links = menu.querySelectorAll(linkSelector);
            if (!links.length) Drupal1.behaviors.trestonMenu.observer.observe(menu, observerConf);
        }
    };
})(jQuery, Drupal, drupalSettings);

})();
//# sourceMappingURL=treston_menu.js.map
